// TODO get from sku entity
import buildSkuName from '../../../../models/modules/buildSkuName.js'

export default {
  '': [
    {
      src: 'sellerRef',
      fill: sellerRef => {
        const { key, contact, phone, email, fax, address } = sellerRef

        const seller = { key, contact, phone, email, fax, address }

        return { seller }
      },
    },
  ],
  'items.0': {
    src: 'skuRef',
    fill: sku => ({
      sku,
      name: buildSkuName(sku),
    }),
  },
}
